import React, { Component } from "react";
import moment from "moment";

import { dateRenderer, dateSorter, defaultSorter } from "./Helpers";
import UserModel from "./UserModel";

import IntelliportCommandsModel from "./IntelliportCommandsModel";

import {
    Table,
    Badge,
    Divider,
    Row,
    Col,
    Card,
    Popconfirm,
    Typography,
    message,
    Tag,
    Tooltip,
} from "antd";

class IntelliportCommandsTable extends Component {
    state = {
        children: [],
    };

    columns = [
        {
            title: "Sériové číslo senozoru",
            dataIndex: "sensor_serial_number",
            key: "sensor_serial_number",
            width: 200,
            sorter: (a, b) =>
                defaultSorter(a.sensor_serial_number, b.sensor_serial_number),
        },
        {
            title: "Čas vytvoření",
            dataIndex: "created_timestamp",
            key: "created_timestamp",
            width: 160,
            defaultSortOrder: "descend",
            sorter: (a, b) =>
                dateSorter(a.created_timestamp, b.created_timestamp),
            render: (text, record) => dateRenderer(text),
        },
        {
            title: "Čas vykonání",
            dataIndex: "executed_timestamp",
            key: "executed_timestamp",
            width: 160,
            defaultSortOrder: "descend",
            sorter: (a, b) =>
                dateSorter(a.executed_timestamp, b.executed_timestamp),
            render: (text, record) => {
                if (text == null) {
                    return null;
                } else {
                    return dateRenderer(text);
                }
            },
        },
        {
            title: "Typ příkazu",
            dataIndex: "command_type",
            width: 200,
            ellipsis: true,
            key: "command_type",
            filters: [
                { text: "Start/Stop firmware update", value: "50" },
                { text: "Set parameters", value: "43" },
                { text: "Get Parameters", value: "48" },
                { text: "Request RF params", value: "2" },
            ],
            render: (text, record) => {
                if (text == "43") {
                    return "Set parameters";
                } else if (text == "50") {
                    return "Start/Stop firmware update";
                } else if (text == "48") {
                    return "Get Parameters";
                } else if (text == "2") {
                    return "Request RF params";
                } else {
                    return text;
                }
            },
            onFilter: (value, record) =>
                record.command_type.indexOf(value) === 0,
            sorter: (a, b) => a.command_type - b.command_type,
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Priorita",
            dataIndex: "priority",
            width: 150,
            ellipsis: true,
            key: "priority",
            sorter: (a, b) => a.priority - b.priority,
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "parametry příkazu",
            dataIndex: "command_parameters",
            ellipsis: true,
            key: "command_parameters",
            render: (text, record) => {
                if (text == "---" || text == null) {
                    return null;
                } else {
                    return text;
                }
            },
        },
        {
            title: "Akce",
            key: "Action",
            width: 200,
            render: (text, record) => {
                if (
                    UserModel.isInRoles([
                        "ADMIN",
                        "INTELLIPORT_COMMANDS_WRITE",
                    ]) &&
                    record.executed_timestamp == null
                ) {
                    return (
                        <div>
                            <Popconfirm
                                placement="right"
                                title="Opravdu si přejete tento příkaz smazat?"
                                okText="Ano"
                                cancelText="Ne"
                                onConfirm={() => {
                                    IntelliportCommandsModel.remove(record.id)
                                        .then(() => {
                                            message.success(
                                                "Příkaz byl odstraněn!"
                                            );
                                            this.props.onRowRemoved();
                                        })
                                        .catch(() => {
                                            message.error(
                                                "Příkaz se nepodařilo smazat!"
                                            );
                                        });
                                }}
                            >
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <Typography.Text type="danger">
                                        Smazat
                                    </Typography.Text>
                                </a>
                            </Popconfirm>
                        </div>
                    );
                }
            },
        },
    ];

    render() {
        return (
            <Table
                size="small"
                rowKey={this.props.rowKey ? this.props.rowKey : "id"}
                loading={this.props.loading ? this.props.loading : false}
                columns={this.columns}
                dataSource={this.props.data}
                pagination={{
                    showSizeChanger: true,
                    defaultPageSize:
                        localStorage.getItem("table_pageSize") !== undefined
                            ? parseInt(localStorage.getItem("table_pageSize"))
                            : 10,
                    onShowSizeChange: (current, size) => {
                        localStorage.setItem("table_pageSize", size);
                    },
                }}
                style={{ border: "0px" }}
            />
        );
    }
}

export default IntelliportCommandsTable;



// WEBPACK FOOTER //
// ./src/components/IntelliportCommandsTable.js